import { createContext } from 'react';

import { PointsDisplay } from '../types/timeseries-props.js';

export const TimeseriesPointsDisplayContext =
  createContext<PointsDisplay>('auto');

TimeseriesPointsDisplayContext['displayName'] =
  'TimeseriesPointsDisplayContext';
